import { render, staticRenderFns } from "./Blade.vue?vue&type=template&id=70a01c7b&"
import script from "./Blade.vue?vue&type=script&lang=js&"
export * from "./Blade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports